class SubscriptionDiscountedPrices {
  prices: SubscriptionDiscountedPriceType[];

  constructor(params?: SubscriptionDiscountedPricesListSerialized) {
    this.prices = params?.prices || [];
  }
}

export { SubscriptionDiscountedPrices };
